import axiosInstance from "./BaseService";
import GroupData from "../models/GroupData";

// Function to fetch groups for logged-in user
const fetchMyGroups = async (page: number = 1, limit: number = 12, search: string = '') => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            ...(search && { search })
        });
        const response = await axiosInstance.get(`/groups/my-groups?${params}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to update group details (only allowed fields)
const updateMyGroup = async (groupId: string, groupData: Partial<GroupData>): Promise<GroupData> => {
    try {
        const response = await axiosInstance.put<GroupData>(`/groups/${groupId}`, groupData);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export {
    fetchMyGroups,
    updateMyGroup
};